var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 198.361,
    height: 99.926,
    viewBox: "774 330 198.361 99.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89",
    transform: "translate(774 330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.49 15.62 34.955 33.54-11.96 13.265-34.953-33.541L84.49 15.62Z",
    fillRule: "evenodd",
    fill: "url(\"#a\")",
    transform: "translate(-36.885 -15.563)",
    "data-name": "Path 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.218 0H47.82a8.218 8.218 0 0 1 8.218 8.218 8.218 8.218 0 0 1-8.218 8.217H8.218A8.218 8.218 0 0 1 0 8.218 8.218 8.218 0 0 1 8.218 0z",
    fillRule: "evenodd",
    fill: "url(\"#b\")",
    transform: "translate(15.5 83.491)",
    "data-name": "Rectangle 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.644 0 0 49.734l12.906 12.36 47.568-49.679L47.644 0Z",
    fill: "#df1681",
    fillRule: "evenodd",
    "data-name": "Path 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.533 91.103c0 4.853 3.721 8.823 8.268 8.823 4.548 0 8.27-3.97 8.27-8.823V60.099c0-4.855-2.782-5.992-6.182-2.528 0 0-10.356 10.369-10.356 13.146v20.386Z",
    fill: "#df1681",
    fillRule: "evenodd",
    "data-name": "Path 3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.594 12.123a2.01 2.01 0 1 1-4.02-.001 2.01 2.01 0 0 1 4.02.001Z",
    fill: "#6d6f72",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.594 12.123a2.01 2.01 0 1 1-4.02-.001 2.01 2.01 0 0 1 4.02.001Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.811 93.02a2.01 2.01 0 1 1-4.019 0 2.01 2.01 0 0 1 4.02 0Z",
    fill: "#6d6f72",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.811 93.02a2.01 2.01 0 1 1-4.019 0 2.01 2.01 0 0 1 4.02 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("image", {
    width: 150,
    height: 21,
    xlinkHref: "data:image/png;base64,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",
    "data-name": "woningmarkt.nl",
    transform: "translate(48.361 49.3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.777,
    y1: 0.981,
    x2: 0.223,
    y2: 0.019,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c21077",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bf1075",
    offset: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b51070",
    offset: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a51167",
    offset: 0.507
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f125a",
    offset: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72134a",
    offset: 0.752
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f1436",
    offset: 0.865
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25161e",
    offset: 0.972
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a1718",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.062,
    y1: -0.363,
    x2: 0.938,
    y2: 1.363,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a1718",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43122c",
    offset: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d0d41",
    offset: 0.187
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900952",
    offset: 0.293
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ad0561",
    offset: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3036c",
    offset: 0.523
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d30173",
    offset: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dd0078",
    offset: 0.798
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0007a",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginlogo);
export default __webpack_public_path__ + "static/media/loginlogo.386f19ea17adbe9b415097b0e2cddfc2.svg";
export { ForwardRef as ReactComponent };